// 主页
import React from "react";
import { Grid, Hidden } from "@material-ui/core";
import Slides from "./components/Slides";
import Articles from "./components/Articles";
import Notifications from "./components/Notifications";
import NotificationsMobile from "./components/NotificationsMobile";

export default function Index(): JSX.Element {
  return (
    <>
      <Grid container justify="center">
        <Hidden smUp>
          <Grid item xs={12}>
            <NotificationsMobile />
          </Grid>
        </Hidden>
        <Grid item xs={12} md={8}>
          <Slides />
        </Grid>
        <Grid item xs={12} sm={8}>
          <Articles />
        </Grid>
        <Hidden xsDown>
          <Grid item xs={12} sm={4}>
            <Notifications />
          </Grid>
        </Hidden>
      </Grid>
    </>
  );
}
